import type { InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...props}
      className={`w-full rounded-xl border border-ink-200 bg-white px-3 py-2.5 text-base text-ink-900 outline-none transition focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20 dark:bg-ink-800 dark:border-ink-700 dark:text-ink-50 ${props.className ?? ''}`}
    />
  );
}

export function Textarea(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      {...props}
      className={`w-full rounded-xl border border-ink-200 bg-white px-3 py-2 text-sm text-ink-900 outline-none transition focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20 dark:bg-ink-800 dark:border-ink-700 dark:text-ink-50 ${props.className ?? ''}`}
    />
  );
}

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      {...props}
      className={`w-full rounded-xl border border-ink-200 bg-white px-3 py-2.5 text-sm text-ink-900 outline-none transition focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20 dark:bg-ink-800 dark:border-ink-700 dark:text-ink-50 ${props.className ?? ''}`}
    />
  );
}
